import { TopNavPublic } from "../../features";

export function ReturnHomeScreenCallPage(): JSX.Element {
  return (
    <>
      <TopNavPublic />
      <div className="container py-5 text-center">
        <h4>Join a conference</h4>
        <p>Use the conference link provided by your host to join a call.</p>
      </div>
    </>
  );
}
